import { render, staticRenderFns } from "./GeneralInfoCard.vue?vue&type=template&id=cf91ad3c&scoped=true"
import script from "./GeneralInfoCard.vue?vue&type=script&lang=js"
export * from "./GeneralInfoCard.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfoCard.vue?vue&type=style&index=0&id=cf91ad3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf91ad3c",
  null
  
)

export default component.exports